import TableTopicSubtopics from "./TableTopicSubtopics"; // Основной компонент

export default TableTopicSubtopics; // Экспорт по умолчанию